import { observable } from 'mobx';

import Model from './Model';


class Technology extends Model {
  static basePath = '/api/technologies';
  static verboseName = 'Technology';

  @observable name;
  @observable factories = [];

  toString() {
    if (this.isLoaded) {
      return this.name;
    }
    return super.toString();
  }
}


export default Technology;
